import { Navigate } from 'react-router-dom';
import { paths } from '../../routes/paths';

/** Legado: /income/new redirecciona para o registo rápido em /income. */
export function IncomeNew() {
  return <Navigate to={paths.incomeRegister} replace />;
}

export default IncomeNew;
